export default {
    device: state =>  state.device,
    geoPosition: state =>  state.geoPosition,
    reservationDate: state =>  state.reservationDate,
    loader: state =>  state.loader,
    reservationDateForServer: (state) => {
        let date = state.reservationDate
        let ds = date ? date.split("/") : '';
        return  `${ds[2]}-${ds[1]}-${ds[0]}`
    },
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/global/getters.js
// module id = null
// module chunks = 